import Http from './http'

export const getProductCategories = (token) => {
    return Http.get('/api/product-categories', { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Delete this product
 *
 * @param {string} productId
 * @param {string} token
 */
export const deleteProduct = (productId, token) => {
    return Http.delete(`/api/products/${productId}`, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Update this product
 *
 * @param {string} product
 * @param {string} token
 *
 * @returns {Promise}
 */
export const updateProduct = (productId, product, token) => {
    // eslint-disable-next-line camelcase
    const { name, fiscal_id, price, physical } = product
    return Http.put(`/api/products/${productId}`, {
        name: name,
        fiscal_id: fiscal_id,
        price: price,
        physical: physical,
    }, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Duplicate this product
 *
 * @param {string} productId
 * @param {string} token
 */
export const duplicateProductV2 = (productId, token) => {
    return Http.post(`/v2/api/products/${productId}/clone`, {}, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Duplicate this product
 *
 * @param {string} productId
 * @param {string} token
 */
export const duplicateProduct = (productId, token) => {
    return Http.post(`/api/products/${productId}/clone`, {}, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Get this product
 *
 * @param {string} productId
 * @param {string} token
 */
export const getProduct = (productId, token) => {
    return Http.get(`/api/products/${productId}`, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Delete this product
 *
 * @param {string} productId
 * @param {string} token
 */
export const deleteProductV2 = (productId, token) => {
    return Http.delete(`/v2/api/products/${productId}`, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Get all active products v2
 *
 * @param {string} product
 * @param {string} token
 *
 * @returns {Promise}
 */
export const getAllProductV2 = (token) => {
    return Http.get(`/v2/api/products`, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Get this product
 *
 * @param {string} product
 * @param {string} token
 *
 * @returns {Promise}
 */
export const getProductV2 = async(productId, token) => {
    return await Http.get(`/v2/api/products/${productId}`, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Update this product
 *
 * @param {string} product
 * @param {string} token
 *
 * @returns {Promise}
 */
export const updateProductV2 = (productId, product, token) => {
    return Http.put(`/v2/api/products/${productId}`, product, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Create a product V2
 *
 * @param {string} product
 * @param {string} token
 *
 * @returns {Promise}
 */
export const createProductV2 = (product, token) => {
    return Http.post('/api/products/v2', product, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Create a product
 *
 * @param {string} product
 * @param {string} token
 *
 * @returns {Promise}
 */
export const createProduct = (product, token) => {

    // eslint-disable-next-line camelcase
    const { name, fiscal_id, price, physical } = product
    return Http.post('/api/products', {
        name: name,
        fiscal_id: fiscal_id,
        price: price,
        physical: physical,
    }, { headers: { Authorization: `Bearer ${token}` } });

}

/**
 * Create a product
 *
 * @param {string} product
 * @param {string} token
 *
 * @returns {Promise}
 */
export const createProductPlan = (productPlan, token) => {

    // eslint-disable-next-line camelcase
    const { name, frete, price, product_id, qty } = productPlan
    return Http.post('/v2/api/plan', {
        name: name,
        product_id: product_id,
        price: price,
        frete: frete,
        qty: qty,
    }, { headers: { Authorization: `Bearer ${token}` } });
}

/**
 * Delete a product plan
 *
 * @param {string} product
 * @param {string} token
 *
 * @returns {Promise}
 */
export const deleteProductPlan = (productId, token) => {
    // eslint-disable-next-line camelcase
    return Http.delete('/v2/api/plan/' + productId, { headers: { Authorization: `Bearer ${token}` } })
}

/**
 * Get all products
 *
 * @param {string} token
 *
 * @returns {Promise}
 */
export const getAllProducts = (token) => {
    return Http.get('/api/products', { headers: { Authorization: `Bearer ${token}` } })
}

export const getAllProductsPlan = (token) => {
    return Http.get(`/v2/api/products/full`, { headers: { Authorization: `Bearer ${token}` } })
}

export const getAllProductsV2 = (token) => {
    return Http.get(`/v2/api/products`, { headers: { Authorization: `Bearer ${token}` } })
}